import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { Wrap } from '@wegroup/design-system';
import useSessionId from '../../../../../../../flows/src/hooks/useSessionId';
import { useLouiseSelector } from '../../../../../store/redux/store';
import useRiskObjectOffersStatus from '../../../hooks/useRiskObjectOffersStatus';
import { getTextForRiskObject } from '../../../../../services/productFactoryService';
import OffersSidebarRiskObjectsItem from './OffersSidebarRiskObjectsItem';
import useOffersPageParams from '../../../hooks/useOffersPageParams';
import { ThemeContext } from 'styled-components';
import RiskObjectIcon from '../../../../../../../common/src/components/RiskObjectIcon';
import useIsSelectedOffersPage from '../../../hooks/useIsSelectedOffersPage';
import useIsNewRoute from '../../../hooks/useIsNewRoute';

const OffersSidebarRiskObjects: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const history = useHistory();
  const theme = useContext(ThemeContext);
  const isNewRoute = useIsNewRoute();

  const sessionId = useSessionId();
  const { getStatus } = useRiskObjectOffersStatus();
  const { riskObject } = useOffersPageParams();
  const selectedRiskObjects = useLouiseSelector(
    (state) => state.selection.selectedRiskObjects,
  );
  const isSelectedOffersPage = useIsSelectedOffersPage();

  const handleClick = (riskObject: string) => {
    history.push(
      `/sales-conversation/offers/overview/${riskObject}?session_id=${sessionId}`,
    );
  };

  return (
    <Wrap
      w="full"
      direction={isSelectedOffersPage ? 'row' : 'column'}
      justifyContent="flex-start"
      spacing="4"
      py="8"
      paddingBottom={isSelectedOffersPage ? '5' : '8'}
      overflow="hidden"
      borderBottom={isNewRoute ? 'unset' : '1px'}
      borderColor="secondary.300"
      justify="center"
    >
      {(selectedRiskObjects.length ? selectedRiskObjects : [riskObject || ''])
        .sort()
        .map((riskKey) => (
          <OffersSidebarRiskObjectsItem
            key={riskKey}
            icon={
              <RiskObjectIcon
                riskObject={riskKey}
                isImmo={theme['isImmo']}
                color={
                  riskKey === riskObject
                    ? theme.primary[500]
                    : theme.secondary[700]
                }
              />
            }
            isActive={riskKey === riskObject}
            isCollapsed={isSelectedOffersPage}
            onClick={() => handleClick(riskKey)}
            status={getStatus(riskKey)}
          >
            {getTextForRiskObject(riskKey)}
          </OffersSidebarRiskObjectsItem>
        ))}
    </Wrap>
  );
};

export default OffersSidebarRiskObjects;
